import React from "react";
import { LogRenderContext } from "../LogRenderer";
import ClearCancelled from "../common/ClearCancel";

const CampaignClearCancelled = () => {
  const { log } = React.useContext(LogRenderContext);
  const { campaign } = log.dataSnapshot;
  const {
    campaign: { updatedBy, updatedAt },
  } = log.changedFields;
  const { name, id } = campaign;
  return <ClearCancelled name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default CampaignClearCancelled;
